<template>
    <div>
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>

        <Loader v-if="loading" />
        <div v-else-if="data.id">






            <hr>
            <p>Обложка курса:</p>
            <img v-if="data.image" :src="data.image" alt="" height="300" class="shadow">
            <p v-else class="alert alert-info">Необходимо загрузить изображение:</p>
            <p style="font-weight: bold; font-size: 80%;">картинка должна быть широкой!</p>
            <form @submit.prevent="submit">
                <!-- <div class="form-group">
                    <input type="text" class="form-control" placeholder="Name" v-model="name">
                </div> -->
                <div class="form-group">
                    <div class="custom-file">
                        <input type="file"
                            class="custom-file-input"
                            id="customFile"
                            @change="onAttachmentChange"
                        >
                        <label class="custom-file-label" for="customFile">Выберите файл для загрузки</label>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary">Сохранить обложку</button>
                </div>
                <div class="alert alert-danger" v-if="errors.uploadfile">
                    {{ errors.uploadfile }}
                </div>
            </form>
            <hr>




            <form>
                <input type="hidden" name="id" v-model="data.id">
                <p>Состояние Курса: <span v-bind:class="{ 'text-success': data.coursestate.id == 5, 'text-muted': data.coursestate.id == 1 }" style="font-weight: bold;">{{ data.coursestate.name }}</span></p>
                <div class="form-group">
                    <label for="name" class="col-form-label">Название курса:</label>
                    <input type="text" class="form-control" id="name" name="name" v-model="data.name">
                    <div class="alert alert-danger" v-if="errors.validationEdit && errors.validationEdit.name">
                        {{ errors.validationEdit.name[0] }}
                    </div>
                    <div class="form-group">
                        <label for="department" class="col-form-label">Кафедра:</label>
                        <select class="form-control" v-model="data.department_id" :required="true">
                            <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id" :selected="department.id == data.department_id" >{{department.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="category" class="col-form-label">Категория:</label>
                        <select class="form-control" v-model="data.category_id" :required="true">
                            <option v-for="category in categories" v-bind:value="category.id" v-bind:key="category.id" :selected="category.id == data.category_id" >{{category.name}}</option>
                        </select>
                    </div>

                    <label for="name" class="col-form-label">Примерная длительность (время на прохождение курса):</label>
                    <input type="text" class="form-control" id="duration" name="duration" v-model="data.duration">
                    <div class="alert alert-danger" v-if="errors.validationEdit && errors.validationEdit.duration">
                        {{ errors.validationEdit.duration[0] }}
                    </div>


                </div>
                <div class="form-group">
                    <label class="col-form-label">Описание курса:</label>
                    <textarea class="form-control" name="description" id="description" cols="30" rows="10" v-model="data.description"></textarea>

                    <!--
                    <Editor
                        api-key="API_KEY"
                        v-model="data.description"
                        :init="{
                            height: 800,
                            skin: 'oxide-dark',
                            plugins: 'wordcount', 
                            //menubar: 'insert',
                            image_advtab: true, 
                            //images_upload_url: '/upload1', 
                            automatic_uploads: true, 
                            file_picker_types: 'image', 
                            images_upload_handler: uploadImage
                        }"
                        plugins = 'image link insertdatetime table emoticons media'
                        toolbar = 'image link insertdatetime table emoticons media'
                    />
                    -->

                </div>
                <!--
                <div class="form-group">
                    <label for="coursestate" class="col-form-label">Coursestate:</label>
                    <select v-model="data.coursestate_id" :required="true">
                        <option v-for="coursestate in coursestates" v-bind:value="coursestate.id" v-bind:key="coursestate.id" :selected="coursestate.id == data.coursestate_id" >{{coursestate.name}}</option>
                    </select>
                </div>
                -->



            </form>
            <button type="button" class="btn btn-primary" @click.prevent="editRecord()">Сохранить изменения</button>
            <div class="alert alert-danger" v-if="errors.edit">
                {{ errors.edit }}
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
// import Editor from '@tinymce/tinymce-vue'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
export default {

    watch: {
        data: {
            attachment: null,
            /*
            handler: function(val, oldVal) {
                //console.log(val, oldVal);
                // это щас не исп-ся, тут можно отслеживать изменение в data
                console.log('WATCH-325!');
            }
            */
        }
    },

    data() {
        return {
            loading: true,
            data: [],
            departments: [],
            categories: [],
            coursestate: '',
            //coursestates: [],
            errors: {load: '', edit: '', validationEdit: {}, uploadfile: ''},
            //selectedDepartment: '',  удалить !!
            bcrumbs: [],
            title: 'Редактирование Курса',
        }
    },


    async mounted() {
       this.loadData()
    },

    methods: {
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/courses/'+this.$route.params.id+'/edit')
                this.data = response.data.course
                this.departments = response.data.departments
                this.categories = response.data.categories
                this.coursestate = response.data.coursestate
                this.bcrumbs = response.data.bcrumbs
                //this.coursestates = response.data.coursestates
                this.loading = false
            }
            catch (e) {
                if (e.response.status == 401) {
                    this.errors.load = 'Нет доступа.'
                }               
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
            }
        },


        onAttachmentChange (e) {
            this.attachment = e.target.files[0]
        },

        submit () {
            this.errors.uploadfile = ''
            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('attachment', this.attachment)

            axios.post('admin/courses/'+this.data.id+'/courseUploadImage', formData, config)
                .then(response => {
                    this.data.image = response.data.image
                    //console.log(response);
                })
                .catch(error => {
                    if (error.response.status == 520) {
                        this.errors.uploadfile = error.response.data.error
                    }
                    if (error.response.status == 422) {
                        this.errors.uploadfile = error.response.data.errors.attachment[0]
                    }
                    else {
                        this.errors.uploadfile = 'Неизвестная ошибка при загрузке файла.'
                    }
                })
        },



        //
        // Edit record.
        //
        async editRecord() {
            this.errors.validationEdit = {}
            this.errors.edit = ''
            try {
                //let response = await axios.post('admin/courses/'+this.data.id, {id: this.data.id, name: this.data.name, description: this.data.description, department_id: this.data.department_id, _method: 'PUT'})
                let response = await axios.post('admin/courses/'+this.data.id,  Object.assign(this.data, {_method: 'PUT'}))
                if (response.status == 200) {
                    this.loadData()
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationEdit = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.edit = e.response.data.error
                }
                else {
                    this.errors.edit = "Неизвестная ошибка при редактировании записи."
                }
            }
        },

        /*
        uploadImage(blobInfo, success, failure) {
            this.errors.uploadfile = ''
            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('file', blobInfo.blob(), blobInfo.filename());

            //formData.append('name', this.name)
            //formData.append('attachment', this.attachment)

            //axios.post('chapters/testUpload', formData, config)
            axios.post('admin/courses/'+this.data.id+'/uploadimage', formData, config)
                //.then(response => console.log(response.data.message))
                //.catch(error => console.log(error))
                .then(response => {
                    console.log(response.data);
                    success(response.data.location);
                })
                .catch(error => {
                    failure('HTTP Error.'+error.response.data.errors.file[0]);
                    if (error.response.status == 520) {
                        this.errors.uploadfile = error.response.data.error
                    }
                    else {
                        this.errors.uploadfile = 'Неизвестная ошибка при загрузке файла.'
                    }
                })
        },
        */

    },

    components: {
        Loader,
        // Editor,
        BreadCrumbs,
        PageTitle,
    },


  
}

</script>